/**
 * RetestCharacterPage - Ретест персонажа (legacy)
 */

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { ucpService } from "../../api/services/ucpService";
import { characterService } from "../../api/services/characterService";

const RetestCharacterPage = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [textSituation1, setTextSituation1] = useState([]);
    const [textSituation2, setTextSituation2] = useState([]);
    const [val, setVal] = useState("");
    const [kventa, setKventa] = useState("");
    const [traits, setTraits] = useState("");
    const [skills, setSkills] = useState("");
    const [appearance, setAppearance] = useState("");
    const [situation1, setSituation1] = useState("");
    const [situation2, setSituation2] = useState("");
    const [skinVariable, setSkinVariable] = useState(1);
    const [gender, setGender] = useState("");
    const [sex, setSex] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await ucpService.getRoleSituations();
                setTextSituation1(result?.situations?.[0] || {});
                setTextSituation2(result?.situations?.[1] || {});
            } catch (err) {
                console.error(err.message);
            }

            try {
                const result = await ucpService.getCharacterInfo(id);
                setKventa(result.prehistory);
                setTraits(result.traits);
                setSkills(result.skills);
                setAppearance(result.appearance);
                setVal(result.name);

                let enGender = "";
                switch (result.gender) {
                    case 1:
                        enGender = "human";
                        break;
                    case 2:
                        enGender = "elf";
                        break;
                    case 4:
                        enGender = "dwarf";
                        break;
                    case 6:
                        enGender = "nimf";
                        break;
                    default:
                        enGender = "human";
                }
                setGender(enGender);
                const enSex = result.sex === 0 ? "male" : "female";
                setSex(enSex);
                setSkinVariable(result.startSkinVariable);
            } catch (err) {
                console.error(err.message);
            }
        };
        fetchData();
    }, [id]);

    const handleRetestCharacter = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        try {
            const data = await characterService.retestCharacter({
                character_id: payload.character_id,
                character_prehistory: payload.character_prehistory,
                character_traits: payload.character_traits,
                character_skills: payload.character_skills,
                character_appearance: payload.character_appearance,
                role_situation_1: payload.id_situation1,
                answer_situation_1: payload.character_situation1,
                role_situation_2: payload.id_situation2,
                answer_situation_2: payload.character_situation2,
            });
            if (data === true) {
                window.location.href = "/ucp/";
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
        }
    };

    return (
        <div className="ucp-main">
            <div className="ucp-two-blocks-container">
                <div>
                    <button
                        className="ucp-simple-blur-button ucp-button-back"
                        onClick={() => {
                            window.location.href = "/ucp";
                        }}
                    >
                        НАЗАД
                    </button>
                    <div className="character-body">
                        <img
                            src={
                                "/media/" +
                                gender +
                                "_" +
                                sex +
                                "_" +
                                skinVariable +
                                ".png"
                            }
                            alt=""
                        />
                        <span>
                            {(val.split(" ")[0] || "").toUpperCase()}
                            <br />
                            {val.split(" ").length > 1
                                ? val.split(" ")[1].toUpperCase()
                                : ""}
                            <br />
                            {val.split(" ").length > 2
                                ? val.split(" ")[2].toUpperCase()
                                : ""}
                        </span>
                    </div>
                </div>
                <SimpleBar className="ucp-second-container">
                    <form onSubmit={handleRetestCharacter}>
                        <h1>ИМЯ ПЕРСОНАЖА</h1>
                        <div className="ucp-simple-info-block">{val}</div>
                        <h1>КВЕНТА ПЕРСОНАЖА</h1>
                        <textarea
                            name="character_prehistory"
                            className="ucp-simple-input-text"
                            placeholder="Краткая предыстория персонажа"
                            maxLength={500}
                            minLength={10}
                            value={kventa}
                            onChange={(e) =>
                                setKventa(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_traits"
                            className="ucp-simple-input-text"
                            placeholder="Черты характера персонажа"
                            maxLength={500}
                            minLength={10}
                            value={traits}
                            onChange={(e) =>
                                setTraits(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_skills"
                            className="ucp-simple-input-text"
                            placeholder="Увлечения, умения, навыки"
                            maxLength={500}
                            minLength={10}
                            value={skills}
                            onChange={(e) =>
                                setSkills(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <textarea
                            name="character_appearance"
                            className="ucp-simple-input-text"
                            placeholder="Внешний вид, особые приметы, привычки"
                            maxLength={500}
                            minLength={10}
                            value={appearance}
                            onChange={(e) =>
                                setAppearance(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "180px" }}
                        />
                        <h1>РОЛЕВЫЕ СИТУАЦИИ</h1>
                        <div className="ucp-simple-info-block">
                            {textSituation1["content"]}
                        </div>
                        <input
                            type="hidden"
                            name="id_situation1"
                            value={textSituation1["id"]}
                        />
                        <textarea
                            name="character_situation1"
                            className="ucp-simple-input-text"
                            placeholder="Ответ на ролевую ситуацию"
                            maxLength={400}
                            minLength={10}
                            value={situation1}
                            onChange={(e) =>
                                setSituation1(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "150px" }}
                        />
                        <div className="ucp-simple-info-block">
                            {textSituation2["content"]}
                        </div>
                        <input
                            type="hidden"
                            name="id_situation2"
                            value={textSituation2["id"]}
                        />
                        <textarea
                            name="character_situation2"
                            className="ucp-simple-input-text"
                            placeholder="Ответ на ролевую ситуацию"
                            maxLength={400}
                            minLength={10}
                            value={situation2}
                            onChange={(e) =>
                                setSituation2(
                                    e.target.value.replace(/[&%#@*<>]/g, ""),
                                )
                            }
                            style={{ minHeight: "150px" }}
                        />
                        <input type="hidden" name="character_id" value={id} />
                        <button
                            type="submit"
                            className="ucp-simple-yellow-button"
                        >
                            ОТПРАВИТЬ РЕТЕСТ
                        </button>
                    </form>
                </SimpleBar>
            </div>
        </div>
    );
};

export default RetestCharacterPage;
